module.exports = {
	"next": "다음",
	"skip": "건너띄기",
	"cancel": "취소",
	"back": "뒤로",
	"sign up": "클라우드 생성",
	"add email": "이메일 주소 추가",
	"welcome": "환영합니다!",
	"confirm": "확인",
	"user missing properties": "Sorry but this user doesnt exist.",
	"step welcome user": "Welcome %{name}!",
	"step welcome anon": "Welcome!",
	"step welcome logout": "You're not %{name}?",
	"step welcome congrats": "Congratulation, thanks to you, your personal data are in a safe place, in your Cozy.",
	"step welcome next": "Next",
	"step agreement title": "Terms of Service",
	"step agreement subtitle": "In order to access your Cozy, you have to read and agree to our terms of service. As any human being, we guess you won't. Here is a short version of these we made just for you:",
	"step agreement element 0": "Take control and responsibility of your data, at home!",
	"step agreement element 1": "We take care of you and your cozy...",
	"step agreement element 2": "...unless you do something wrong with Cozy or your data",
	"step agreement element 3": "Choose which services use your data and understand their goal",
	"step agreement element 4": "Nobody (even us) can access your data in your Cozy",
	"step agreement element 5": "We have a few details about you, for legal reasons or service quality only",
	"step agreement stats": "I allow Cozy to collect data anonymously",
	"step agreement description 1": "You can access the full terms of service",
	"step agreement description 2": "By clicking on the button \"accept\", you acknowledge that you have read, understood, and agree to be bound by these terms.",
	"step agreement description link": "here.",
	"step agreement next": "Accept",
	"step preset": "설정",
	"step import": "데이터 가져오기",
	"step email settings": "이메일 설정",
	"preset email": "이메일",
	"preset email tip": "비밀번호 분실시 이 이메일 주소를 사용합니다.",
	"preset name": "이름",
	"step password empty": "Password's value is missing.",
	"step password too weak": "Your password is too weak. You should add an uppercase, a number, a special character or a longer password.",
	"step password title": "Secure your password",
	"step password label": "password",
	"step password input placeholder": "e.g. \"dEj875ghj9273;eR\"",
	"step password submit": "confirm",
	"step password show": "Show password",
	"step password hide": "Hide password",
	"step password description": "Your password has to be as complicated as possible. It will prevent malicious people to access your own cloud. Using an uppercase, a number and a special character is mandatory.",
	"step password server error": "Something went wrong. Your password has not been saved.",
	"step infos title": "Complete your Cozy",
	"step infos description": "Some information are necessary to set up your Cozy.",
	"step infos public_name label": "Username",
	"step infos public_name placeholder": "The public display name your Cozy will use to speak with you.",
	"step infos email label": "Email",
	"step infos email placeholder": "Used by your Cozy to reset your password.",
	"step infos timezone label": "Timezone",
	"step infos timezone placeholder": "Your timezone helps to properly display your calendar.",
	"step infos submit": "Confirm",
	"step infos fetch data error": "Unable to fetch data from server.",
	"missing public_name": "You need to fill your username.",
	"missing email": "You need to fill your email.",
	"invalid email format": "Your email address doesn't seem correct.",
	"missing timezone": "You need to choose a timezone",
	"invalid timezone": "Your timezone doesn't seem correct.",
	"step accounts title": "Your Cozy has been successfully created!",
	"step accounts description line 1": "Now, we will accompagny you to connect your Cozy to your services.",
	"step accounts description line 2": "In the end, Cozy's goal is to help you reclaim your data!",
	"step accounts next": "Browse",
	"myaccounts info": "You can now access your Cozy at anytime by clicking 'Continue'",
	"myaccounts next": "Continue",
	"step confirmation title": "Welcome to your personal cloud!",
	"step confirmation description line 1": "Your Cozy is now ready.",
	"step confirmation description line 2": "You can get back your data from many services, and install the applications you want from our store.",
	"step confirmation next": "Enter",
	"step server error": "An error occurred while saving your progression. Reloading the page should fix the problem.",
	"preset name tip": "파일을 공유하거 이벤트 초대시 사용 됩니다.",
	"preset password": "비밀번호",
	"preset password tip": "최소 8자 이상이어야 합니다(특수문자 권장).",
	"preset timezone": "시간대",
	"preset timezone tip": "캘린더 표시시 정확한 시간을 표시 하는데 필요 합니다.",
	"preset opt-in help": "클라우드 향상을 위해 시스템 내용을 사용하도록 허용 합니다.",
	"preset opt-out newsletter": "Cozy 뉴스레터(권장).",
	"import from google": "구글 계정에서 데이터 가져오기",
	"import google account": "G메일 계정과 캘린더, 주소록, 사진을 동기화 합니다.",
	"import google account tip": "클라우드가 구글 계정에 접근 하도록 허용합니다.",
	"leave google title": "Cozy로 데이터를 제공 합니다",
	"leave google help me": "지원 요청!",
	"leave google sign in content": "클라우드가 구글 계정에 접근 하도록 허용합니다.",
	"leave google sign in": "구글 로그인",
	"leave google code content": "팝업 창에서 복사한 코드를 여기에 붙여 넣으세요:",
	"leave google code": "구글 코드",
	"leave google url doc": "https://docs.cozy.io/en/mobile/import-google.html",
	"leave google choice": "구글 서버에 저장된 데이터 중 필요한 것을 선택:",
	"leave google choice sync gmail": "GMail - 클라우드 접근 하도록 허용",
	"leave google choice contacts": "한번만 주소록 가져오기",
	"leave google choice calendar": "한번만 캘린더 가져오기",
	"leave google choice photos": "한번만 구글 사진 가져오기",
	"leave google confirm": "가져오기",
	"import error": "데이터를 가져오는 중 오류가 발생 하였습니다. 잠시 후에 다시 시도해 주세요.",
	"login welcome user": "Welcome %{username}",
	"login welcome anon": "Welcome",
	"login enter your password": "Enter your password to access your Cozy",
	"login password": "비밀번호",
	"login otp": "인증코드",
	"login submit": "Log in",
	"login auth success": "인증 성공!",
	"login recover": "Forgotten password? Send me an email to change it.",
	"login recover busy": "Sending an email containing instructions",
	"login recover sent title": "이메일 보냄",
	"login recover sent message": "이메일을 확인해 주세요. 비밀번호를 초기화 하기 위하여 다음 단계를 실행 하세요.",
	"login recover error title": "이메일을 보내는 중에 오류가 발생했습니다.",
	"login recover error message": "이메일을 통해 비밀번호를 보내는중에 오류가 발생 하였습니다. 메 일 서버 또는 관리자에게 문의하세요.",
	"login wrong password title": "잘못된 인증",
	"login wrong password message": "The credentials you entered are incorrect. Please try again.",
	"login server error": "An error occured, please try again.",
	"reset password request success title": "Email sent",
	"reset password request success message": "Check your emails, and follow the instructions to change your password.",
	"reset password request error": "An error occurred, the email has not been sent. Please try again. If the error persists, contact us at contact@cozycloud.cc.",
	"reset welcome user": "Change your password",
	"reset enter your password": "%{username}, set a new password to recover access to your Cozy.",
	"reset password": "비밀번호",
	"reset submit": "비밀번호 초기화",
	"reset auth success": "비밀번호가 초기화 되었습니다.",
	"reset wrong password title": "비밀번호를 초기화 하지 못했습니다.",
	"reset wrong password message": "입력된 비밀번호가 올바르지 않거나, 사용기한이 종료 되었습니다.",
	"reset password error invalid key": "Your password request has expired. Please request a new one.",
	"reset password error password too weak": "Your password is too weak. You should add an uppercase, a number, a special character or a longer password.",
	"setup title": "클라우드를 설정 중입니다…",
	"setup message": "설정이 거의 완료 되었습니다.",
	"setup on mobile title": "안드로이드 장치에서 클라우드를 경험해 보세요!",
	"setup on mobile message": "구글 플레이에서 모바일 앱 설치:",
	"welcome title": "Congratulations on taking back control of your personal data!",
	"welcome message": "You can now store your data on your own personal cloud. As opposed to most cloud services, there is no data-mining taking place on your Cozy."
};


//////////////////
// WEBPACK FOOTER
// ./app/locales/ko.json
// module id = 44
// module chunks = 0